import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { TransportationOrderStatus } from '../../../app/models/TransportationOrderStatus';
import useOrderService from '../../../app/services/hooks/useOrderService';
import { TransportationOrderStatuses } from '../../../app/shared/enums';

interface Props {
    orderId: number;
    statuses: TransportationOrderStatus[];
    selectedStatus: TransportationOrderStatus;
    callbackSuccess?: () => void;
}

const OrderChangeStatus = ({
    orderId,
    statuses,
    selectedStatus,
    callbackSuccess,
}: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [selected, setSelected] = React.useState<TransportationOrderStatus>(selectedStatus);

    const { changeStatusUnifiedOrder } = useOrderService();

    const changeStatus = (value: string) => {
        if (value === selected.id) return;
        const _status = statuses.find((s) => s.id === value);
        if (!_status) return;

        let confirmMessage = `Está a punto de cambiar el estado del pedido #${orderId} a ${_status.name}.`;
        if (_status.id === TransportationOrderStatuses.ANULADO) {
            confirmMessage = `Está a punto de Anular el pedido #${orderId}, este cambiará a estado Activo.`;
        }

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: confirmMessage,
            buttons: {
                confirmButton: {
                    label: 'Sí, cambiar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Cambiando estado...');
                        changeStatusUnifiedOrder(orderId, String(_status.id), {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();
                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message,
                                });
                                setSelected(_status);
                                if (callbackSuccess) callbackSuccess();
                            },
                            onError: (response: ServiceResponse) => {
                                setSelected(selectedStatus);
                                if (hideLoading) hideLoading();
                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message,
                                    message_list: response.data?.message_list ?? [],
                                });
                            },
                        });
                    },
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            setSelected(selectedStatus);
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El estado del pedido no se ha cambiado.',
                            });
                        }, 0);
                    },
                },
            },
            onClickOutsideFunction: () => {
                setSelected(selectedStatus);
            },
        });
    };

    if (!selectedStatus) return null;

    return (
        <select
            className="form-control"
            value={selected.id}
            onChange={(e) => changeStatus(String(e.target.value))}
        >
            <option value={selectedStatus.id}>{selectedStatus.name}</option>
            {statuses
                .filter((s) => s.id !== selectedStatus.id)
                .map((s) => (
                    <option key={s.id} value={s.id}>
                        {s.name}
                    </option>
                ))}
        </select>
    );
};

export default OrderChangeStatus;
